import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { useTranslation } from 'react-i18next';
import { useAppSearchParams } from '@utils/hooks/use-app-search-params.ts';

export interface TeamUser {
  email: string;
  first_name: string;
  last_name: string;
  id: number;
}

export type TeamUserListResponse = BaseResponse<TeamUser[]>;

export const useGetUsersOfTeam = (
  teamId: string
): UseQueryResult<TeamUserListResponse, AxiosError<BaseError>> => {
  const { t } = useTranslation();
  const { searchParams } = useAppSearchParams();
  const offset = searchParams.offset || '0';
  const limit = searchParams.limit || '1000';

  const fetchUsers = async (
    offset: string | undefined = undefined,
    limit: string | undefined = undefined
  ) => {
    try {
      const response = await Axios.get<TeamUserListResponse>(
        `${GET_URL(teamId, offset, limit).teamUsers}`
      );
      return response.data;
    } catch (error) {
      throw new Error(t('an-error-occurred-while-fetching-the-team'));
    }
  };

  return useQuery<TeamUserListResponse, AxiosError<BaseError>>(
    ['teamUsers', teamId],
    () => fetchUsers(offset, limit)
  );
};
